<template>
  <v-layout row justify-center>
    <v-dialog
      transition="slide-y-transition"
      v-model="blockDriverDialog"
      max-width="570"
      persistent
      @keydown.esc="close"
    >
      <v-card class="confirm-dialog">
        <v-card-title>
          <v-layout align-center justify-space-between dialog-title>
            {{
              blockDriver.isBlocked
                ? $t('unblockDriverDialog.title')
                : $t('blockDriverDialog.title')
            }}
            <v-icon class="svg-icon ml-4" @click="close">mdi-close</v-icon>
          </v-layout>
        </v-card-title>
        <v-card-actions>
          <v-layout align-center justify-center class="btns-wrapper mt-4 mb-4">
            <v-btn
              type="button"
              :ripple="false"
              :disabled="isLoading"
              class="error mb-4 mr-4"
              depressed
              @click="close"
            >{{ $t('common.btns.cancel') }}</v-btn>
            <v-btn
              type="button"
              :ripple="false"
              :disabled="isLoading"
              class="warning mb-4"
              depressed
              @click="changeDriverBlockStatus"
            >
              {{ blockDriver.isBlocked ? $t('common.btns.unblock') : $t('common.btns.block') }}
            </v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';

export default {
  name: 'BlockDriverDialog',
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters({
      dialog: 'driver/getBlockDriverDialogState',
      blockDriver: 'driver/getBlockDriver',
      isLoading: 'global/getLoader',
    }),
    blockDriverDialog: {
      get() {
        return this.dialog;
      },
      set(value) {
        if (!value) {
          this.close();
        }
      },
    },
  },
  methods: {
    ...mapActions({
      changeBlockStatus: 'driver/changeDriverBlockStatus',
    }),
    ...mapMutations({
      clearAlertError: 'global/clearAlertError',
      clearAlertSuccess: 'global/clearAlertSuccess',
      setAlertSuccess: 'global/setAlertSuccess',
      setLoader: 'global/setLoader',
      setBlockDriverDialogState: 'driver/setBlockDriverDialogState',
      setBlockDriver: 'driver/setBlockDriver',
    }),
    async changeDriverBlockStatus() {
      this.setLoader(true);
      try {
        const message = await this.changeBlockStatus({
          driverId: this.blockDriver.driverId,
        });

        this.setAlertSuccess({ message, state: true });
        this.changeBlockState();
        this.$vuetify.goTo('#alerts', 'easeInOutCubic');

        setTimeout(() => {
          this.clearAlertSuccess();
        }, 3000);
        this.clearAlertError();
        this.close();
      } catch (error) {
        this.close();
      }
    },
    close() {
      this.setBlockDriverDialogState(false);
      this.setBlockDriver({});
      this.setLoader(false);
    },
    changeBlockState() {
      this.$emit('changeBlockState');
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-title {
    word-break: break-word;
}
</style>
